<div class="grid-container">
	<div class="column">
		<div class="centered-div" [hidden]="typingMode || isRecording || startAnimation">
			<div fxLayout="row" class="record-section" *ngIf="(typingMode || isRecording) && startAnimation">
				<cd-timer format="ms"></cd-timer>
			</div>
		</div>
	</div>
	<div class="column">
		<div class="centered-div">
			<img class="lottie-button inner-button" #lottieButton (click)="startResponse.emit()" [src]="'assets/images/lottie/lottie-record.png'" *ngIf="!(typingMode || isRecording) && !startAnimation" [@fadeOut]="startAnimation ? 'void' : '*'" />
			<div *ngIf="!typingMode; else textAction">
				<ng-lottie (click)="stopResponse.emit()" [options]="options" height="48px" width="auto" class="lottie-button" *ngIf="(typingMode || isRecording) && startAnimation" [@fadeIn]="typingMode || isRecording ? '*' : null"></ng-lottie>
			</div>
			<ng-template #textAction>
				<div class="reset" *ngIf="typeReady" [@fadeIn]="typingMode || isRecording ? '*' : null">
					<img class="lottie-button inner-button" #lottieButton (click)="stopResponse.emit()" [src]="'assets/images/lottie/lottie-record-back.png'" />
				</div>
			</ng-template>
		</div>
	</div>
	<div class="column">
		<div class="centered-div" *ngIf="!(typingMode || isRecording) && !startAnimation" [@fadeOut]="startAnimation ? 'void' : '*'">
			<button [disableRipple]="true" [hidden]="!isMobile" *ngIf="!audioMode" class="inner-right-button" mat-fab-icon (click)="switchCameraView.emit()">
				<fa-icon icon="camera-rotate"></fa-icon>
			</button>
		</div>
	</div>
</div>

<!--<div class="grid-container">-->
<!--	<div class="column">-->
<!--		<div class="centered-div" [hidden]="isRecording || startAnimation">-->
<!--			<div fxLayout="row" class="record-section" *ngIf="isRecording && startAnimation">-->
<!--				<cd-timer format="ms"></cd-timer>-->
<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
<!--	<div class="column">-->
<!--		<div class="centered-div">-->
<!--			<img class="lottie-button inner-button" #lottieButton (click)="switchTypingMode();" [src]="'assets/images/lottie/lottie-record.png'" *ngIf="!isRecording && !startAnimation"  [@fadeOut]="startAnimation ? 'void' : '*'">-->
<!--			&lt;!&ndash;										<ng-lottie (click)="stopResponse.emit()" [options]="options" height="56px" width="auto" class="lottie-button" *ngIf="isRecording && startAnimation" [@fadeIn]="isRecording ? '*' : null"></ng-lottie>&ndash;&gt;-->
<!--		</div>-->
<!--	</div>-->
<!--	<div class="column">-->
<!--		<div class="centered-div" *ngIf="typeReady" [@fadeIn]="typeReady ? '*' : 'void'" (click)="resetTypingMode()">-->
<!--			<button-->
<!--				[disableRipple]="true"-->
<!--				class="inner-right-button"-->
<!--				mat-fab-icon-->
<!--			>-->
<!--				<fa-icon icon="rotate-left"></fa-icon>-->
<!--			</button>-->
<!--		</div>-->
<!--	</div>-->
<!--</div>-->
